export default "__VITE_ASSET__DVrfhW$V__"